import t from "../../translations";

const greenQuotation = [
  t('green_quotation'),
  ];
  
  export default greenQuotation;
  